import type { ReactNode } from "react";
import { UnauthorisedState } from "@/components/feedback/states";
import { LoadingState } from "@/components/feedback/states";
import { useAuth, type PrincipalKind } from "./auth-context";
import { useLocale } from "@/features/localisation/locale-context";

export function RoleGuard({
  allow,
  children,
}: {
  allow: readonly PrincipalKind[];
  children: ReactNode;
}) {
  const { locale } = useLocale();
  const { principal, roles, isLoading } = useAuth();
  if (isLoading)
    return <LoadingState label={locale === "th" ? "กำลังตรวจสอบสิทธิ์" : "Checking access"} />;
  const allowed = allow.includes(principal) || roles.some((role) => allow.includes(role));
  return allowed ? children : <UnauthorisedState />;
}
